import { cx } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";
import {
	PrimaryButton,
	TextPrimaryButton,
} from "src/components/Default/LekUI/Button";
import {
	Modal,
	ModalContent,
	ModalFooter,
	ModalTitle,
} from "src/components/Modals/Components/ModalsComponents";
import { ModalMaxWidth } from "src/types/enums";

interface RestoreDeckDraftModalProps {
	onClose: () => void;
	onRestore: () => void;
	onDiscard: () => void;
	count: number;
}

export const RestoreDeckDraftModal = ({
	onClose,
	onRestore,
	onDiscard,
	count,
}: RestoreDeckDraftModalProps) => {
	const { t } = useTranslation();

	return (
		<Modal onClose={onClose} maxWidth={ModalMaxWidth.sm}>
			<ModalTitle
				title={t("creators.decks.draftModal.title", "Masz niezapisany zestaw")}
			/>
			<ModalContent>
				<p className={cx("text-center", "m-0")}>
					<Trans
						i18nKey="creators.decks.draftModal.description"
						count={count}
						values={{ count }}
						components={{ b: <strong /> }}
					/>
				</p>
			</ModalContent>
			<ModalFooter>
				<TextPrimaryButton
					data-test-id="restore-draft-discard-button"
					onClick={() => {
						onDiscard();
						onClose();
					}}
				>
					{t("creators.decks.draftModal.discard", "Zacznij od nowa")}
				</TextPrimaryButton>
				<PrimaryButton
					data-test-id="restore-draft-confirm-button"
					onClick={() => {
						onRestore();
						onClose();
					}}
				>
					{t("creators.decks.draftModal.restore", "Przywróć")}
				</PrimaryButton>
			</ModalFooter>
		</Modal>
	);
};
